import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import MemberVerification from '../components/MemberVerification';
import { useQuery } from 'react-query';
import { getUserById } from '../api/user';
import BenefitList from '../components/BenefitList';

interface MerchantPageProps {}

const MerchantPage: React.FC<MerchantPageProps> = () => {
  const authUser = useContext(UserContext);

  return (
    <div className="ceas-max-w-7xl ceas-mx-auto sm:ceas-px-6 lg:ceas-px-8 ceas-mt-7 ceas-mb-7">
      <div className="ceas-bg-white ceas-shadow ceas-overflow-hidden sm:ceas-rounded-lg">
        <div className="ceas-px-4 ceas-py-5 sm:ceas-px-6">
          <div className="ceas-flex ceas-flex-col ceas-justify-center ceas-items-center">
            {authUser?.merchant_data?.merchant_gravatar && (
              <div className="ceas-h-60 ceas-w-60 ceas-rounded-full ceas-overflow-hidden">
                <img
                  className="ceas-object-cover ceas-h-60"
                  src={authUser?.merchant_data?.merchant_gravatar}
                  alt="merchant avatar"
                />
              </div>
            )}
            <h1 className="ceas-text-2xl ceas-font-medium ceas-text-gray-900">{authUser?.name}</h1>
          </div>
        </div>
        <div className="ceas-border-t ceas-border-gray-200 ceas-px-4 ceas-py-5 sm:ceas-p-0">
          <dl className="sm:ceas-divide-y sm:ceas-divide-gray-200">
            <div className="ceas-py-4 sm:ceas-py-5 sm:ceas-grid sm:ceas-grid-cols-3 sm:ceas-gap-4 sm:ceas-px-6">
              <dt className="ceas-text-sm ceas-font-medium ceas-text-gray-500">Verify Member</dt>
              <dd className="ceas-mt-1 ceas-text-sm ceas-text-gray-900 sm:ceas-mt-0 sm:ceas-col-span-2">
                <MemberVerification />
              </dd>
            </div>
            <div className="ceas-py-4 sm:ceas-py-5 sm:ceas-grid sm:ceas-grid-cols-3 sm:ceas-gap-4 sm:ceas-px-6">
              <dt className="ceas-text-sm ceas-font-medium ceas-text-gray-500">Benefits</dt>
              <dd className="ceas-mt-1 ceas-text-sm ceas-text-gray-900 sm:ceas-mt-0 sm:ceas-col-span-2">
                <BenefitList merchant={authUser?.id} lg_grid="2" sm_grid="1" />
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default MerchantPage;
